import React, { useState, useEffect } from 'react';

import edit from '../../../../assets/images/icons/edit.svg';
import remove from '../../../../assets/images/icons/remove.svg';
import close from '../../../../assets/images/icons/close.svg';
import save from '../../../../assets/images/icons/save.svg';

import styles from './Topic.module.scss';
import { API_URL } from '../../../../actions';
import { useGlobalContext } from '../../../context/GlobalContext';

export default function Topic({
  propTopic,
  setRemoveAction,
  index,
  theme,
  openSelectPicture,
  handleChangeTopic,
  deleteTopic,
}) {
  const [context] = useGlobalContext();
  const [topic, setTopic] = useState(propTopic || {});
  const [isEdit, setIsEdit] = useState(!propTopic);

  async function handleChange(obj) {
    const topicData = { ...topic, ...obj };
    await setTopic(topicData);
    if (Object.keys(obj).includes('picture')) {
      await handleChangeTopic(topicData, index);
    }
  }

  function saveTopic(bool) {
    if (index >= 0) {
      handleChangeTopic(topic, index);
    }
    setIsEdit(bool);
  }

  function cancelTopic() {
    setTopic(propTopic || {});
    setIsEdit(false);
  }

  function renderImgLarge() {
    const foundImg = topic.picture && context?.medias?.mediasList?.find(
      (item) => item._id === topic.picture?._id || item._id === topic.picture
    );
    if (topic.picture?.path) {
      return <img src={API_URL + '/' + topic.picture.path} alt="topic" className="img-large" />;
    }
    if (foundImg) {
      return <img src={API_URL + '/' + foundImg.path} alt="topic" className="img-large" />;
    }
  }

  useEffect(() => {
    if (!propTopic) {
      setIsEdit(true);
    } else {
      setTopic(propTopic);
    }
    // eslint-disable-next-line
  }, [propTopic?.picture]);

  function renderEdit() {
    return (
      <>
        <div className="btn-close-row">
          <button
            type="button"
            style={{ width: 30 }}
            onClick={() => saveTopic(false)}
          >
            <img src={save} alt="save" />
          </button>
          <button
            type="button"
            onClick={cancelTopic}
          >
            <img src={close} alt="close" />
          </button>
        </div>

        <label htmlFor={`Topic${index}.title`}>Titre</label>
        <input
          name={`Topic${index}.title`}
          style={{ marginBottom: 10 }}
          onChange={(e) => handleChange({ title: e.target.value })}
          value={topic?.title || ''}
        />

        <label>
          Photo d'illustration <span className={`${theme}-color required`}>*</span>
          <br /><span className="note">minimum 900 x 600 px , 72 dpi</span>
        </label>
        {renderImgLarge()}
        <div style={{ marginBottom: 20 }} className="btn-container">
          <button
            type="button"
            style={{ marginRight: 20 }}
            className={`btn primary ${theme}-bg`}
            onClick={() => openSelectPicture(`formations.topics.${index}.picture`)}
          >
            Parcourir
          </button>
          {topic?.picture && (
            <button
              type="button"
              className={`btn primary ${theme}-bg`}
              onClick={() => setRemoveAction({ function: async () => handleChange({ picture: null }) })}
            >
              Supprimer
            </button>
          )}
        </div>
      </>
    );
  }

  function renderRow() {
    return (
      <>
        <div className={styles.name}>
          <p className="bold">{topic?.title}</p>
        </div>
        <div className="actions">
          <button type="button" onClick={() => setIsEdit(true)}>
            <img src={edit} alt="edit" />
          </button>
          {setRemoveAction && (
            <button
              type="button"
              onClick={() => setRemoveAction({ function: () => deleteTopic(index) })}
            >
              <img src={remove} alt="remove" />
            </button>
          )}
        </div>
      </>
    );
  }

  return (
    <div id={`topic${index}`} className={`${styles.topic} ${!isEdit ? styles.row : styles.edit}`}>
      {isEdit ? renderEdit() : renderRow()}
    </div>
  );
}
